<h1>Google start auth. 
<br>Please don't close window and wait...</h1> 